import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {PageHeader} from 'antd';
import { pageSectionTitle } from '../util/Style';

import LabDetails from './LabDetails';
import LabReceivableStore from '../stores/LabReceivableStore';


class LabSummary extends Component {

    constructor(props) {
        super(props);
        const referrerId = props.params.referrerId;
        const collectionType = props.params.collectionType;
        this.store = new LabReceivableStore({ apiProxy: props.appStore.apiProxy, referrerId, collectionType });
    }


    render() {
        const labName = this.props.params.labName;

        return (
            <PageHeader style={{ paddingTop: 0 }} title={pageSectionTitle(labName)}>
                <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: "5px" }}>
                    <div style={{ width: '100%' }}>
                        <LabDetails params={this.props.params} store={this.store} />
                    </div>
                </div>
            </PageHeader>
        )
    }
}

export default observer(LabSummary)
